/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    email: z.string(),
    inviterId: z.string(),
    role: z.string(),
    status: z.string().default("pending"),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date().default(() => new Date()),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    email: z.string(),
    inviterId: z.string(),
    role: z.string(),
    status: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    organization: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    organizationId: z.string(),
}
);

/**
 * `Invitation` schema excluding foreign keys and relations.
 */
export const InvitationScalarSchema = baseSchema;


/**
 * `Invitation` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const InvitationSchema = InvitationScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const InvitationPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const InvitationPrismaUpdateSchema = z.object({
    id: z.string(),
    email: z.string(),
    inviterId: z.string(),
    role: z.string(),
    status: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date()
}).partial().passthrough();


/**
 * `Invitation` schema for create operations excluding foreign keys and relations.
 */
export const InvitationCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    id: true, status: true, createdAt: true
});


/**
 * `Invitation` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const InvitationCreateSchema = InvitationCreateScalarSchema.merge(fkSchema);


/**
 * `Invitation` schema for update operations excluding foreign keys and relations.
 */
export const InvitationUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Invitation` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const InvitationUpdateSchema = InvitationUpdateScalarSchema.merge(fkSchema.partial());

